import { NotificationLevel, NotificationsService } from './../../../../services/api/notifications/notifications.service';
import { TaskManagementService,Queue } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-assign-queue',
  templateUrl: './assign-queue.component.html',
  styleUrls: ['./assign-queue.component.scss']
})
export class AssignQueueComponent implements OnInit {

  queuesOptions: any[] = [];
  form: FormGroup;
  queues: Queue[] = [];

  constructor(
    private taskManagementService:TaskManagementService,
    private notificationsService:NotificationsService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AssignQueueComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      taskid: string;
    }) { }

  ngOnInit() {

    this.getQueues();
    
    this.form = this.formBuilder.group({
      queuesFormControl: this.formBuilder.control({value:'',disabled: false},Validators.required),
    });
  }

  confirm(){
    if(this.validateForm())
    {
      this.taskManagementService.assignQueue(this.form.get('queuesFormControl').value,this.data.taskid).subscribe(
        () => {
          this.notificationsService.showNotification(`Asignación a cola se ha ejecutado correctamente`, NotificationLevel.SUCCESS);
          this.dialogRef.close();
        },
        (error) => {
          this.notificationsService.showNotification(
            `Ha habido un problema al asignar la tarea a la cola`,
            NotificationLevel.ERROR);
        }
      )
    } else {
      this.notificationsService.showNotification(`Debe seleccionar una cola para poder realizar la asignación`, NotificationLevel.ERROR);
    }
  }

  validateForm(): boolean {
    return this.form.get('queuesFormControl').value != ''
  }

  getQueues(){
    this.taskManagementService.getQueues().subscribe(
    data =>{
      
      this.queues = <Queue[]>data
      
      this.queues.forEach(queue => {
        this.queuesOptions.push({ text: queue.name, value: queue.queueId});  
      })

    },
    (error) => {
      this.notificationsService.showNotification(
        `Ha habido un problema al recuperar las colas`,
        NotificationLevel.ERROR);
    });  
  }

  get queuesFormControl(): FormControl {
    return this.form.get('queuesFormControl') as FormControl;
  }

}
